import * as React from 'react';
import { Box, Tooltip, TooltipProps } from '@chakra-ui/react';
import { Icon } from '~/ui-components';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

export type IconTooltipProps = Omit<TooltipProps, 'children'> & {
   boxposition?: 'absolute' | 'relative' | 'fixed' | 'static' | 'sticky' | 'initial' | 'inherit';
   boxtop?: number;
   boxright?: number;
   icon: IconDefinition;
};

export function IconTooltip(props: IconTooltipProps) {
   return (
      <Tooltip hasArrow placement="bottom" bg="blueGray.700" color="white" {...props}>
         {/* The tooltip trigger */}
         <Box
            position={props.boxposition ?? 'absolute'}
            top={props.boxtop ?? 3}
            right={props.boxright && 4}
         >
            <Icon type={props.icon} color="blueGray.600" />
         </Box>
      </Tooltip>
   );
}
